// Generated by CoffeeScript 2.3.2

import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
;
var TopBar;

TopBar = function(props) {
  return <AppBar position="static">
    <Toolbar>
      <IconButton color="inherit" onClick={function(event) {
      return props.app.showMainMenu(event.currentTarget);
    }}>
        <MenuIcon />
      </IconButton>
      <Typography variant="h6" color="inherit">
        Not A Clue
      </Typography>
    </Toolbar>
  </AppBar>;
};

export default TopBar;
